import { Link } from "react-router-dom";
import DeleteButton from "../../UI/DeleteButton";

const SingleRefView = (props) => {
    const referenceName = props.reference.fieldData.name;

    return (
        <div
            id={props.id}
            className="max-w-xs overflow-hidden bg-white rounded-lg border shadow-sm hover:shadow-md transition-shadow duration-300"
        >
            <h2 className="px-4 pt-4 font-semibold text-gray-800">{referenceName}</h2>
            <img
                src={props.reference.fieldData.logo && props.reference.fieldData.logo.url}
                alt={referenceName}
                className="w-full h-32 object-cover object-center"
            />
            <div className="flex justify-between items-center p-4">
                <Link
                    to={`/reference-form/${props.id}`}
                    className="edit-button px-3 py-1 border rounded-lg text-indigo-600 border-indigo-600 hover:bg-indigo-600 hover:text-white transition-colors duration-300"
                >
                    Edit
                </Link>
                <DeleteButton
                    handleDelete={() => props.handleDelete(props.id)}
                    confirmTitle={`Delete "${referenceName}"?`}
                    confirmMessage={
                        "This will permanently delete:\n" +
                        "• The customer logo from the marketing site (Webflow)\n" +
                        "• All linked addresses and their pins on the map\n\n" +
                        "This action cannot be undone."
                    }
                />
            </div>
        </div>
    );
};

export default SingleRefView;
